import { TreeDiv, TreeSelectLocal } from 'components/TreeSelect/style'
import SelectArrowIcon from 'components/icons/SelectArrowIcon'
import React from 'react'
import isValidUUID from '../../utils/isValidUUID'
import { EmptySpan } from '../UIComponents/CommonStyledDiv'
import CloseIcon from '../icons/CloseIcon'
const { SHOW_CHILD } = TreeSelectLocal

const TreeSelect = ({
  showSearch = false,
  treeData,
  treeCheckable = true,
  placeholder,
  onChange,
  height,
  label,
  id = 'treeStyle',
  listHeight = 200,
  ...props
}) => {

  const renderTag = option => {
    return (
      !isValidUUID(option.label) && (
        
        <div
          className="ant-select-selection-overflow-item"
          style={{
            position: 'relative',
            opacity: 1,
            display: 'flex',
          }}
        >
          <span
            className="ant-select-selection-item ant-select-selection-item-disabled"
            style={{ lineHeight: '32px', height: '32px' }}
          >
            <span className="ant-select-selection-item-content">
              {' '}
              {option.label}
            </span>
            {!option.disabled && option.closable && (
              <EmptySpan
                className="ant-select-selection-item-remove"
                aria-hidden="true"
                onClick={option.onClose}
                style={{ userSelect: 'none', cursor: 'pointer' }}
              >
                <CloseIcon />
              </EmptySpan>
            )}
          </span>
        </div>
      )
    )
  }
  return (
    <TreeDiv id={id}>
      {}
      <label>{label}</label>
      <TreeSelectLocal
        showSearch={showSearch}
        listHeight={listHeight}
        treeData={treeData}
        treeCheckable={treeCheckable}
        placeholder={placeholder}
        onChange={onChange}
        tagRender={renderTag}
        suffixIcon={<SelectArrowIcon />}
        showCheckedStrategy={SHOW_CHILD}
        height={height}
        getPopupContainer={() => document.body}
        dropdownStyle={{
          zIndex: 99999,
          background: '#FFFFFF',
          border: '1px solid #EBECEE',
          boxShadow: '0px 2px 6px rgba(123, 97, 255, 0.15)',
          borderRadius: '10px',
        }}
        {...props}
      />
    </TreeDiv>
  )
}

export default TreeSelect
